import * as React from 'react';

// API
import apibridge from '../../apibridge';

// UTILS
import { checkAndLogErrors } from '../../utils';

// REDUX
import { useAppSelector } from '../../store';

// PACKAGES
import { SwitchTransition, CSSTransition } from 'react-transition-group';

// COMPONENTS
import Button from '../../components/Button';
import LoadingSpinner from '../../components/LoadingSpinner';
import ErrorMessage from '../../components/ErrorMessage';

// ICONS
import { ReactComponent as AlertIcon } from '../../assets/svg/alert.svg';

// TYPES
import { closeModalType } from '../../components/GlobalModal';

interface ReInstateVisitorsModalTypes {
	reinstateVisitorId: string;
	closeModal?: closeModalType;
}

const ReInstateVisitorsModal: React.FC<ReInstateVisitorsModalTypes> = ({ reinstateVisitorId, closeModal }) => {
	const websiteUrl = useAppSelector((state) => state.lists.websiteUrl);

	const [showError, setShowError] = React.useState<boolean>(false);

	const [isLoading, setIsLoading] = React.useState<boolean>(false);

	const reinstateStaff = async () => {
		setIsLoading(true);

		const response = await apibridge.postVisitorsReinstateProfile({ id: reinstateVisitorId });

		if (response.isError) {
			checkAndLogErrors(response);

			setShowError(true);

			setIsLoading(false);
		} else {
			setShowError(false);

			closeModal?.();

			window.location.reload();
		}
	};

	return (
		<div className="modal-confirmation">
			{showError ? (
				<ErrorMessage />
			) : (
				<SwitchTransition mode="out-in">
					<CSSTransition key={`key_${isLoading}`} timeout={600} classNames="standalone-fade" mountOnEnter unmountOnExit>
						{isLoading ? (
							<LoadingSpinner show={isLoading} />
						) : (
							<>
								<figure className="icon">
									<AlertIcon />
								</figure>

								<p className="heading h4">
									Are you sure you wish to <br />
									<strong>reinstate this person to your organisation?</strong>
								</p>

								<p className="heading h4">If you proceed, you agree that you have obtained this person's consent to reinstate them. This person will be notified that they have been reinstated.</p>

								<section className="actions">
									<Button className="btn-primary full-width" onClick={reinstateStaff}>
										Yes
									</Button>

									<Button className="btn-secondary full-width" onClick={closeModal}>
										Cancel
									</Button>
								</section>
							</>
						)}
					</CSSTransition>
				</SwitchTransition>
			)}
		</div>
	);
};

export default ReInstateVisitorsModal;
